const sha256 = {
    hash: async (message: string) => {
        const msgUint8 = new TextEncoder().encode(message);
        const hashBuffer = await crypto.subtle.digest('SHA-256', msgUint8);
        const hashArray = Array.from(new Uint8Array(hashBuffer));

        return hashArray.map((byte) => `00${byte.toString(16)}`.slice(-2)).join('');
    }
};

export default sha256;
